import { render, staticRenderFns } from "./win-prizes-modal.vue?vue&type=template&id=55bf8820&"
import script from "./win-prizes-modal.vue?vue&type=script&lang=js&"
export * from "./win-prizes-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports